import React from 'react';
import { ReactComponent as Bell } from '../assets/svg/bell.svg';
import styled from 'styled-components';

const Notification = ({ message, className }) => (
  <NotificationWrapper className={className}>
    <Icon as={Bell} />
    <Message>{message}</Message>
  </NotificationWrapper>
);


const NotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;

  white-space: pre-wrap;
`;

const Icon = styled.svg`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin: 5px 10px;
  align-self: flex-start;
`;

const Message = styled.div`
  font-size: 0.8em;
`;

export default Notification;
